import { render, staticRenderFns } from "./teacher_info.vue?vue&type=template&id=fc488a2e&scoped=true"
import script from "./teacher_info.vue?vue&type=script&lang=js"
export * from "./teacher_info.vue?vue&type=script&lang=js"
import style0 from "./teacher_info.vue?vue&type=style&index=0&id=fc488a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc488a2e",
  null
  
)

export default component.exports